import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, EffectCoverflow } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";

import waste from "../images/waste.jpg";
import plastic from "../images/plastic.jpg";
import energyOne from "../images/energy-1.jpg";
import water from "../images/water.jpg";
import forest from "../images/forest.jpg";
import green from "../images/green.jpg";

let ServicesSlider = () => {
  return (
    <div>
      <Swiper
        className="servicesSwiper"
        modules={[Navigation, EffectCoverflow]}
        loop={true}
        slidesPerView={3}
        effect="coverflow"
        spaceBetween={20}
        coverflowEffect={{
          depth: 0,
          stretch: -90,
          rotate: 0,
          modifier: 0,
        }}
        navigation={{
          prevEl: ".service-prev",
          nextEl: ".services.next",
        }}
        onInit={(swiper) => {
          swiper.params.navigation.prevEl = ".services-prev";
          swiper.params.navigation.nextEl = ".services-next";
          swiper.navigation.init();
          swiper.navigation.update();
        }}
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
            coverflowEffect: {
              stretch: 0,
            },
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 15,
            coverflowEffect: {
              stretch: -40,
            },
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
            coverflowEffect: {
              stretch: -90,
            },
          },
        }}
      >
        <SwiperSlide>
          <div className="card">
            <img src={waste} alt="Waste-management.jpg" />
            <p> Waste Management</p>
            <p>
              We reduce environmental harm by promoting recycling, composting,
              and responsible waste disposal in communities and businesses.
            </p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="card">
            <img src={plastic} alt="plastic.jpg" />
            <p>Plastic Reduction Initiatives</p>
            <p>
              Our campaigns and partnerships aim to reduce single-use plastics
              and promote biodegradable alternatives in everyday use.
            </p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="card">
            <img src={energyOne} alt="energy-1.jpg" />
            <p>Clean Energy Advocacy</p>
            <p>
              We support the shift to solar, wind, and other renewable energy
              sources to reduce carbon emissions and create a greener future.
            </p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="card">
            <img src={water} alt="water.jpg" />
            <p>Water Conservation Projects</p>
            <p>
              From rainwater harvesting to efficient irrigation, we help
              communities use water effectively and wisely and protect
              freshwater sources.
            </p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="card">
            <img src={forest} alt="forest.jpg" />
            <p>Forest Restoration</p>
            <p>
              We work to replant native trees, restore degraded land, and revive
              natural habitats that support biodiversity and climate resilience.
            </p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="card">
            <img src={green} alt="green.jpg" />
            <p>Green Space Development</p>
            <p>
              We transform urban and rural spaces into eco-friendly zones by
              planting trees, building community gardens, supporting local
              wildlife.
            </p>
          </div>
        </SwiperSlide>
        <div className="swiper-nav">
          <div className="swiper-button-prev services-prev">
            <svg
              fill="rgb(29, 65, 48)"
              version="1.1"
              id="Layer_1"
              width="60px"
              height="800px"
              viewBox="0 0 100 100"
              enableBackground="new 0 0 100 100"
            >
              <g>
                <path d="M39.292,51.5H68c1.104,0,2-0.896,2-2s-0.896-2-2-2H39.043l8.045-7.855c0.781-0.781,0.781-1.952,0-2.733 s-2.048-0.734-2.828,0.047l-11.335,11.36c-0.375,0.375-0.586,0.896-0.586,1.426s0.211,1.045,0.586,1.42l11.336,11.337 c0.391,0.391,0.902,0.587,1.414,0.587s1.024-0.194,1.415-0.585c0.781-0.781,0.781-2.237,0-3.018L39.292,51.5z" />
                <path d="M84.446,49.756c0-18.448-15.009-33.457-33.457-33.457c-18.449,0-33.458,15.009-33.458,33.457 c0,18.449,15.009,33.458,33.458,33.458C69.438,83.214,84.446,68.205,84.446,49.756z M21.531,49.756 c0-16.242,13.215-29.457,29.458-29.457s29.457,13.215,29.457,29.457c0,16.243-13.214,29.458-29.457,29.458 S21.531,65.999,21.531,49.756z" />
              </g>
            </svg>
          </div>
          <div className="swiper-button-next services-next">
            <svg viewBox="0 0 100 100" width="800px" height="800px">
              <circle cx="50" cy="50" r="33.5" fill="rgb(29, 65, 48)" />
              <path
                d="M60.708,48.5H32c-1.104,0-2,0.896-2,2s0.896,2,2,2h29.257l-8.045,7.855c-0.781,0.781-0.781,1.952,0,2.733 s2.048,0.734,2.828-0.047l11.335-11.36c0.375-0.375,0.586-0.896,0.586-1.426s-0.211-1.045-0.586-1.42L54.04,38.298 c-0.391-0.391-0.902-0.587-1.414-0.587s-1.024,0.194-1.415,0.585c-0.781,0.781-0.781,2.237,0,3.018L60.708,48.5z"
                fill="white"
              />
            </svg>
          </div>
        </div>
      </Swiper>
    </div>
  );
};

export default ServicesSlider;
